import React, { useState, useEffect } from 'react';
import { X, Bell, CheckCircle2, Info, AlertCircle } from 'lucide-react';

const NotificationToast = ({ 
    message, 
    type = 'info', 
    onClose, 
    duration = 5000 
}) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, duration);
        return () => clearTimeout(timer);
    }, [duration]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 500); // Wait for animation
    };

    const icons = {
        info: <Info className="text-blue-400" size={20} />,
        success: <CheckCircle2 className="text-green-400" size={20} />,
        error: <AlertCircle className="text-red-400" size={20} />,
        sale: <Bell className="text-primary-orange animate-pulse" size={20} />
    };

    const colors = {
        info: 'border-blue-500/20 bg-blue-500/10',
        success: 'border-green-500/20 bg-green-500/10',
        error: 'border-red-500/20 bg-red-500/10',
        sale: 'border-primary-orange/20 bg-primary-orange/10'
    };

    if (!isVisible) return null;

    return (
        <div className={`fixed top-6 right-6 z-[9999] animate-slide-in-right`}>
            <div className={`bg-glass ${colors[type]} p-4 rounded-2xl border flex items-center gap-4 min-w-[300px] shadow-2xl shadow-black/50`}>
                <div className="p-2 bg-white/5 rounded-xl">
                    {icons[type]}
                </div>
                <div className="flex-1">
                    <p className="text-sm font-bold text-white leading-tight">{message}</p>
                </div>
                <button 
                    onClick={handleClose}
                    className="p-1 hover:bg-white/10 rounded-lg transition-colors text-white/40 hover:text-white"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
};

export default NotificationToast;
